export default {
  hotels: state => state.hotels,
  orderedCountries: state => state.orderedCountries,
  filterCountriesList: state => state.filterCountriesList,
  filterCitiesList: state => state.filterCitiesList,
  filterHotelsList: state => state.filterHotelsList,
  filterDestination: state => state.filterDestination,
  filterOccupancy: state => state.filterOccupancy,
  filterDates: state => state.filterDates,
  filtersCleared: state => state.filtersCleared,
  promocodeValidationError: state => state.promocodeValidationError,
  loadingHotels: state => state.loadingHotels,
  validateIdentity: state => state.validateIdentity,
  tmsDates: state => state.tmsDates,
  totalAdults: state =>
    state.filterOccupancy.rooms.reduce(
      (accumulation, current) =>
        accumulation >= parseInt(current.adults) ? accumulation : parseInt(current.adults),
      0
    ),
  totalChildren: state =>
    state.filterOccupancy.rooms.reduce(
      (accumulation, current) =>
        accumulation >= parseInt(current.children) ? accumulation : parseInt(current.children),
      0
    ),

  promotion: state => state.promotion,
  orderedHotels: state =>
    state.hotels
      .filter(hotel => hotel.price !== -1)
      .sort((a, b) => a.distance?.km - b.distance?.km)
      .concat(
        state.hotels
          .filter(hotel => hotel.price === -1)
          .sort((a, b) => a.distance?.km - b.distance?.km)
      ),
  hotelsByLocation: state => {
    const result = state.hotels.reduce((acc, curr, idx, src) => {
      const actualCountry = curr.country
      const actualCountryCode = curr.countryCode
      const hotelsFromCountry = src.filter(({ country }) => country === actualCountry)

      const citiesWithHotels = hotelsFromCountry.reduce((acc, curr, idx, src) => {
        const actualCity = curr.city
        const actualCityCode = curr.cityCode
        const hotelsFromCity = src.filter(({ city }) => city === actualCity)
        const citiesAlreadyAdded = acc.map(({ city }) => city)
        if (citiesAlreadyAdded.indexOf(actualCity) > -1) {
          return acc
        } else {
          acc.push({
            city: actualCity,
            cityCode: actualCityCode,
            hotels: hotelsFromCity,
            cityImage: curr.cityImage
          })
          return acc
        }
      }, [])

      const countriesAlreadyAdded = acc.map(({ country }) => country)
      if (countriesAlreadyAdded.indexOf(actualCountry) > -1) {
        return acc
      } else {
        acc.push({
          country: actualCountry,
          countryCode: actualCountryCode,
          cities: citiesWithHotels
        })
        return acc
      }
    }, [])
    result.forEach(country => country.cities.sort((a, b) => a.city.localeCompare(b.city)))
    return result
  }
}
